module.exports = __webpack_public_path__ + "img/bg_avatar_male_59.35860ed7.png";